__turbopack_context__.v({
  "a": "c8FwBG_a" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "alignCenter": "c8FwBG_alignCenter",
  "alignRight": "c8FwBG_alignRight",
  "h1": "c8FwBG_h1",
  "h2": "c8FwBG_h2",
  "h3": "c8FwBG_h3",
  "h4": "c8FwBG_h4",
  "h5": "c8FwBG_h5",
  "h6": "c8FwBG_h6",
  "richText": "c8FwBG_richText",
  "td": "c8FwBG_td",
  "th": "c8FwBG_th",
  "ul": "c8FwBG_ul",
});
